"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _closeFileViewer = _interopRequireDefault(require("../../../assets/icons/close-file-viewer.svg"));

var _smallDownloadIcon = _interopRequireDefault(require("../../../assets/icons/small-download-icon.svg"));

var _zoomIn = _interopRequireDefault(require("../../../assets/icons/zoom-in.svg"));

var _zoomOut = _interopRequireDefault(require("../../../assets/icons/zoom-out.svg"));

var _typography = _interopRequireDefault(require("../../../components/typography"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FullScreen = function FullScreen(_ref) {
  var file = _ref.file,
      setIsOpen = _ref.setIsOpen;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      percentageZoom = _useState2[0],
      setPercentageZoom = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      base64File = _useState4[0],
      setBase64File = _useState4[1];

  var imgRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (file) {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = function () {
        return setBase64File(fileReader.result);
      };

      if ((file.type || '').includes('image')) {
        setIsOpen(true);
      }
    }
  }, [file]);

  var onCloseClick = function onCloseClick() {
    return setIsOpen(false);
  };

  var onZoomAction = function onZoomAction() {
    var magnify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var imgEl = imgRef === null || imgRef === void 0 ? void 0 : imgRef.current;

    if (imgEl) {
      var aspectRatio = imgEl.width / imgEl.height;
      var currentArea = imgEl.width * imgEl.height;
      var newArea = magnify ? currentArea * 5.0 / 4.0 : currentArea * 3.0 / 4.0;
      var newHeight = Math.sqrt(newArea / aspectRatio);
      var newWidth = Math.sqrt(newArea * aspectRatio);
      imgEl.width = newWidth;
      imgEl.height = newHeight;
      setPercentageZoom(magnify ? percentageZoom + 25 : percentageZoom - 25);
    }
  };

  return file && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenContainer
  }, /*#__PURE__*/_react.default.createElement(TopPanel, {
    file: file,
    base64File: base64File,
    onCloseClick: onCloseClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenImage
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: base64File,
    ref: imgRef
  })), /*#__PURE__*/_react.default.createElement(BottomPanel, {
    onZoomIn: function onZoomIn() {
      return onZoomAction(true);
    },
    onZoomOut: function onZoomOut() {
      return onZoomAction(false);
    },
    percentageZoom: percentageZoom
  }));
};

var BottomPanel = function BottomPanel(_ref2) {
  var onZoomIn = _ref2.onZoomIn,
      onZoomOut = _ref2.onZoomOut,
      percentageZoom = _ref2.percentageZoom;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenBottomPanel
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenBottomPanelZoom
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: _constants.classes.fullScreenBottomPanelZoomIn,
    src: _zoomOut.default,
    onClick: onZoomOut
  }), /*#__PURE__*/_react.default.createElement("img", {
    className: _constants.classes.fullScreenBottomPanelZoomOut,
    src: _zoomIn.default,
    onClick: onZoomIn
  }), percentageZoom && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenBottomPanelZoomPercentage
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "heading6"
  }, "".concat(100 + percentageZoom, " %")))));
};

var TopPanel = function TopPanel(_ref3) {
  var file = _ref3.file,
      base64File = _ref3.base64File,
      onCloseClick = _ref3.onCloseClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenTopPanel
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenTopPanelName
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenTopPanelNameTypeSize
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "heading6"
  }, "".concat(file.name), /*#__PURE__*/_react.default.createElement("br", null), "".concat(file.type.substring(0, file.type.indexOf('/')), " ").concat(Math.round(file.size / 1000), " Kb")))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fullScreenTopPanelNameButtons
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: base64File,
    download: file.name
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _smallDownloadIcon.default
  })), /*#__PURE__*/_react.default.createElement("img", {
    className: _constants.classes.fullscreenTopPanelCloseFile,
    src: _closeFileViewer.default,
    onClick: onCloseClick
  })));
};

var _default = FullScreen;
exports.default = _default;